// extracted by mini-css-extract-plugin
export default {"ariaSkipLinksContainer":"Mh-z"};